import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { CLIENT_AREA_URL } from "@/lib/site";

export default function ClientPortal() {
  return (
    <section id="portale-clienti" data-testid="client-portal-section" className="py-12 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="rounded-3xl border border-[#2A241F] bg-[#1A1714] px-6 py-14 text-center sm:px-12 sm:py-20">
            <p className="section-kicker justify-center">Clienti YieldUp</p>
            <h2 className="mt-4 font-heading text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#FAF7F2] sm:text-4xl lg:text-5xl">
              Il portale della tua struttura
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-[#C4BBB0] sm:text-base">
              Numeri sempre aggiornati, andamento mensile e annuale, note del tuo specialista e report scaricabili. Accedi con le credenziali che ti abbiamo fornito.
            </p>
            <a
              data-testid="client-portal-login-button"
              href={CLIENT_AREA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-glow mt-9 inline-flex items-center gap-2 rounded-full bg-[#E05A2C] px-8 py-3.5 text-sm font-medium text-white transition-colors duration-300 hover:bg-[#F26B3A]"
            >
              Accedi alla mia dashboard
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
